<template>
  <div class="home">
    <Header style="display: block"></Header>
    <div
      class="main"
      style="width: 100%; height: auto; background-color: #000000"
    >
      <!-- 首页轮播图 -->
      <swiper id="swiper" ref="mySwiper" :options="swiperOptions">
        <swiper-slide>
          <img src="@/assets/home/banner1.png" />
          <a class="link_lable link_lable_swiper1" href=""
            ><span>了解更多</span></a
          >
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/home/banner2.png" />
          <a class="link_lable link_lable_swiper1" href=""
            ><span>参与创想</span></a
          >
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/home/banner3.png" />
          <p class="link_picture link_picture_swiper2"></p>

          <a class="link_lable link_lable_swiper2" href=""
            ><span>了解更多</span></a
          >
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/home/banner4.png" />
          <a class="link_lable link_lable_swiper1" href=""
            ><span>了解更多</span></a
          >
        </swiper-slide>
        <swiper-slide>
          <img src="@/assets/home/app1.png" />
          <a class="link_lable link_lable_swiper1" href=""
            ><span>了解更多</span></a
          >
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <!-- -->
      <!-- <div class="swiper-slide__video swiper-slide__video1">
        <img style="width: 100%; height: 700px" src="@/assets/home/app1.png" />
        <a class="link_lable link_lable_video1" href=""
          ><span>应用管理</span></a
        >
      </div> -->

      <!-- 科技创新 -->
      <!-- <div class="swiper-slide__tech">
        <p class="link_picture link_picture_tech"></p>
        <img src="@/assets/home/address.png" />
        <a class="link_lable link_lable_tech" href=""><span>地址管理</span></a>
      </div> -->
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
//require styles
import "swiper/swiper-bundle.min.css";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";

import Swiper2, { Navigation, Pagination, Autoplay, Scrollbar } from "swiper";
Swiper2.use([Navigation, Pagination, Autoplay]);

// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "home",
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOptions: {
        notNextTick: true,
        //循环
        loop: true,
        //自动轮播
        autoplay: {
          delay: 5000,
          stopOnLastSlide: true
        },
        // 分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true // 允许分页点击跳转
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        //滑动速度
        speed: 1000
      },
      swiperOptions2: {
        notNextTick: true,
        //循环
        loop: true,
        //自动轮播
        autoplay: {
          delay: 5000,
          stopOnLastSlide: true
        },
        //滑动速度
        speed: 1000,
        //滚动条
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false, //滚动条是否自动隐藏。默认：false，不会自动隐藏。
          draggable: true, //该参数设置为true时允许拖动滚动条。
          snapOnRelease: true, //如果设置为false，释放滚动条时slide不会自动贴合。
          dragSize: 30 //设置滚动条指示的尺寸。默认'auto': 自动，或者设置num(px)。
        }
      }
    };
  },
  directives: {
    swiper: directive
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#home {
  width: 100%;
  height: auto;
}

#swiper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

#swiper img {
  width: 100%;
  height: 100%;
  background: no-repeat;
  object-fit: cover;
}

.swiper-pagination-bullet-active {
  background-color: rgba(255, 255, 255, 1);
}

.swiper-button-prev {
  margin-left: 7%;
  color: white;
  display: none;
}

.swiper-button-next {
  margin-right: 7%;
  color: white;
  display: none;
}

#swiper:hover .swiper-button-prev {
  display: block;
}

#swiper:hover .swiper-button-next {
  display: block;
}

.car-model1 {
  width: 100%;
  height: 100vh;
  background: url("https://www.mercedes-benz.com.cn/etc/designs/mb-cn/images/model-overview-star.gif");
  background-size: 70% 70%;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.car-model2 {
  background-image: url("https://www.mercedes-benz.com.cn/etc/designs/mb-cn/images/modeloverview-background-pc.png");
  width: 100%;
  height: 100%;
  background-size: 100% 60%;
  background-repeat: no-repeat;
  overflow: hidden;
  background-position: bottom;
}

#swiper2 {
}

.car-model_slide {
  margin: 200px auto;
}

#swiper2 img {
  width: 65%;
  height: 65%;
  object-position: 50% 50%;
  object-fit: cover;
  background: no-repeat;
}

.swiper-slide__video {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  z-index: 1;
}

.swiper-slide-reponse__video {
  position: relative;
  height: calc(100vh - var(--browser-address-bar, 0px));
  font-family: "object-fit:cover;object-position:calc(50% + var(--asset-x-offset-mobile)) calc(50% + var(--asset-y-offset-mobile))";
  object-fit: cover;
  object-position: 50% 50%;
  object-position: calc(50% + var(--asset-x-offset-desktop))
    calc(50% + var(--asset-y-offset-desktop));
  width: 100%;
  z-index: 1;
}

.swiper-slide__tech {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.swiper-slide__tech img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-slide__video1 {
  position: relative;
  z-index: 1;
}

.swiper-slide__video2 {
  position: relative;
  z-index: 1;
}

.link_lable {
  width: 146px;
  height: 40px;
  line-height: 38px;
  border-radius: 2px;
  text-align: center;
  color: #fff;
  border: 1px solid #666;
  font-weight: 500;
  display: block;
  cursor: pointer;
  font-size: 16px;
  letter-spacing: 0.4px;
  font-family: "PingFang SC", "Hiragino Sans GB", "Noto Sans CJK SC",
    "Source Han Sans SC", "Microsoft YaHei", "SimHei", Helvetica, Arial;
  z-index: 100;
  /* background-color: #000; */
  opacity: 1;
}

.link_lable:hover {
  opacity: 0.5;
}

.link_lable_car {
  position: absolute;
  left: 50%;
  margin-left: -73px;
  bottom: 69px;
}

.link_lable_video1 {
  position: absolute;
  top: 450px;
  left: 70%;
}

.link_lable_tech {
  position: absolute;
  top: 250px;
  left: 10%;
}

.link_lable_video2 {
  position: absolute;
  top: 250px;
  left: 22%;
}

.link_lable_video3 {
  position: absolute;
  top: 250px;
  left: 10%;
  color: black;
  background-color: #ffffff;
}

.link_picture_video1 {
  position: absolute;
  z-index: 1;
  top: 100px;
  left: 70%;
}

.link_picture_tech {
  position: absolute;
  z-index: 1;
  top: 100px;
  left: 10%;
}

.link_picture_video2 {
  position: absolute;
  z-index: 1;
  top: 100px;
  left: 10%;
}

.link_lable_swiper1 {
  position: absolute;
  z-index: 1;
  bottom: 145px;
  left: 50%;
  margin-left: -73px;
  background: none;
  border: 1px solid #fff;
  text-align: center;
}

.link_lable_swiper2 {
  position: absolute;
  z-index: 1;
  top: 400px;
  left: 15%;
  background: none;
  border: 1px solid #fff;
}

.link_picture_swiper2 {
  position: absolute;
  z-index: 1;
  top: 230px;
  left: 15%;
}

@media screen and (max-width: 767px) {
  .link_lable {
    margin-left: -73px;
  }

  .link_lable_car {
    position: absolute;
    left: 50%;
    bottom: 69px;
  }

  .link_lable_video1 {
    position: absolute;
    left: 50%;
    bottom: 69px;
  }

  .link_lable_tech {
    position: absolute;
    left: 50%;
    bottom: 69px;
  }

  .link_lable_video2 {
    position: absolute;
    left: 50%;
    bottom: 69px;
  }

  .link_lable_video3 {
    position: absolute;
    left: 50%;
    bottom: 169px;
  }

  .link_picture_video1 {
    position: absolute;
    z-index: 1;
    top: 100px;
    left: 10%;
  }
}
</style>
